/**
 * Ranh giới lỗi — chặn màn hình trắng.
 *
 * Trong PWA, hậu quả nặng hơn ở trang quản trị: một lỗi render làm React tháo
 * toàn bộ cây, và nhân viên đang đứng ở công trường nhận một trang trắng
 * trơn, không nút nào. Họ không chấm công được, và cũng không có gì để chụp
 * màn hình gửi quản lý.
 *
 * ⚠️ Màn hình lỗi này PHẢI nói rõ rằng bản ghi trong hàng đợi vẫn còn. Không
 * nói thì người dùng sẽ gỡ cài đặt app hoặc xoá dữ liệu trang — và lúc đó giờ
 * công chưa đồng bộ mới thật sự mất.
 *
 * React chỉ hỗ trợ ranh giới lỗi qua component lớp. Đây là lý do duy nhất còn
 * `class` trong mã nguồn này.
 */

import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  vung?: string
}

interface State {
  loi: Error | null
}

export default class RanhGioiLoi extends Component<Props, State> {
  state: State = { loi: null }

  static getDerivedStateFromError(loi: Error): State {
    return { loi }
  }

  componentDidCatch(loi: Error, info: ErrorInfo): void {
    console.error('[ranh giới lỗi]', this.props.vung ?? 'ứng dụng', loi,
                  info.componentStack)
  }

  render(): ReactNode {
    const { loi } = this.state
    if (!loi) return this.props.children

    return (
      <div className="man-hinh" role="alert">
        <h1 style={{ fontSize: 'var(--cy-trang)', marginBottom: 'var(--k3)' }}>
          Màn hình này gặp lỗi
        </h1>

        <div className="the-khoi" style={{ marginBottom: 'var(--k4)' }}>
          <p style={{ marginTop: 0 }}>
            <strong>Giờ công của bạn không bị mất.</strong> Những lần chấm công
            chưa gửi được vẫn nằm trong hàng đợi trên máy và sẽ tự gửi khi có
            sóng.
          </p>
          <p style={{ marginBottom: 0 }}>
            <strong>Đừng xoá dữ liệu trang hay gỡ cài đặt ứng dụng</strong> —
            làm vậy mới thật sự mất hàng đợi.
          </p>
        </div>

        <p className="thong-bao-loi">{loi.message}</p>

        <div className="cum-nut">
          <button type="button" className="nut-gui"
                  onClick={() => this.setState({ loi: null })}>
            Thử lại
          </button>
          <button type="button" className="nut-phu"
                  onClick={() => window.location.reload()}>
            Tải lại ứng dụng
          </button>
        </div>

        <p className="ghi-chu-rieng-tu" style={{ marginTop: 'var(--k4)' }}>
          Nếu vẫn lỗi, chụp màn hình này gửi quản lý.
        </p>
      </div>
    )
  }
}
